import React, { useRef } from "react";
import { Link } from "react-router-dom";
import emailjs from "@emailjs/browser";
// Çoklu dil desteği
import { useLanguage } from "../../hooks/useLanguage";

const bg = require("../../images/background/bg3.png");
// style="background-image:url(images/background/bg3.png); background-size: cover;"

const Footer4 = () => {
  const { content } = useLanguage();
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    //emailjs.sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', form.current, 'YOUR_USER_ID')
    emailjs
      .sendForm(
        "service_0btii1e",
        "template_xpxhqtc",
        e.target,
        "yWrf5DHaT0GPYpKtI"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };
  return (
    <>
      <footer className="site-footer">
        <div
          className="footer-top"
          style={{ backgroundImage: "url(" + bg + ")" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-8 col-xl-4 col-lg-4 col-sm-8 footer-col-6">
                <div className="widget widget_services border-0">
                  <ul>
                    <li>
                      <a href="https://www.galsiad.org.tr/" target="_blank" rel="noopener noreferrer">
                        <img src={require("../../images/galsiad-logo.png")} alt=""/>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-md-6 col-xl-4 col-lg-3 col-sm-6 footer-col-4">
                <div className="widget widget_getintuch">
                  <h5 className="footer-title text-white">
                    {content.texts.contactInfo}
                  </h5>
                  <ul>
                    <li>
                      <i className="ti-location-pin"></i>
                      <strong>{content.texts.address}</strong> {content.companyInfo.address}
                    </li>
                    <li>
                      <i className="ti-mobile"></i>
                      <strong>{content.texts.phone}</strong>{content.companyInfo.phone}
                    </li>
                    <li>
                      <i className="ti-email"></i>
                      <strong>{content.texts.email}</strong>{content.companyInfo.email}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-12 col-xl-4 col-lg-4 col-sm-6 footer-col-4 ">
                <div
                  className="col-lg-5 col-lg-12 col-md-12 wow fadeIn"
                  data-wow-delay="0.6s"
                >
                  <div className="icon-bx-wraper bx-style-1 p-a30 m-b15 radius-sm br-col-w1 bg-tpw1">
                    <h5 className="text-white font-weight-300">{content.texts.aboutUs}</h5>
                    <p>
                      {content.companyInfo.description}
                    </p>
                  </div>
                </div>
                {/* <ul
                  className="list-inline m-a0"
                  style={{ display: "flex", justifyContent: "space-around" }}
                >
                  <li>
                    <Link to="https://facebook.com/macoendustri" className="site-button facebook circle ">
                      <i className="fa fa-facebook"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="https://linkedin.com/company/macoendustri" className="site-button linkedin circle ">
                      <i className="fa fa-linkedin"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="https://instagram.com/macoendustri" className="site-button instagram circle ">
                      <i className="fa fa-instagram"></i>
                    </Link>
                  </li>
                </ul> */}
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-sm-6 text-left ">
                {" "}
                <span>Copyright © 2024 Keynect Technologies</span>{" "}
              </div>
              
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
export default Footer4;
